// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import { z } from 'zod';
import { accountCenterFieldControlGuard, webauthnRelatedOriginsGuard, accountCenterProfileFieldsGuard } from './../foundations/index.js';
const createGuard = z.object({
    tenantId: z.string().max(21).optional(),
    id: z.string().min(1).max(21),
    enabled: z.boolean().optional(),
    fields: accountCenterFieldControlGuard.optional(),
    webauthnRelatedOrigins: webauthnRelatedOriginsGuard.optional(),
    deleteAccountUrl: z.string().max(2048).nullable().optional(),
    customCss: z.string().nullable().optional(),
    profileFields: accountCenterProfileFieldsGuard.nullable().optional(),
    maximumAuthenticationAgeInSeconds: z.number().optional(),
});
const guard = z.object({
    tenantId: z.string().max(21),
    id: z.string().min(1).max(21),
    enabled: z.boolean(),
    fields: accountCenterFieldControlGuard,
    webauthnRelatedOrigins: webauthnRelatedOriginsGuard,
    deleteAccountUrl: z.string().max(2048).nullable(),
    customCss: z.string().nullable(),
    profileFields: accountCenterProfileFieldsGuard.nullable(),
    maximumAuthenticationAgeInSeconds: z.number(),
});
export const AccountCenters = Object.freeze({
    table: 'account_centers',
    tableSingular: 'account_center',
    fields: {
        tenantId: 'tenant_id',
        id: 'id',
        enabled: 'enabled',
        fields: 'fields',
        webauthnRelatedOrigins: 'webauthn_related_origins',
        deleteAccountUrl: 'delete_account_url',
        customCss: 'custom_css',
        profileFields: 'profile_fields',
        maximumAuthenticationAgeInSeconds: 'maximum_authentication_age_in_seconds',
    },
    fieldKeys: [
        'tenantId',
        'id',
        'enabled',
        'fields',
        'webauthnRelatedOrigins',
        'deleteAccountUrl',
        'customCss',
        'profileFields',
        'maximumAuthenticationAgeInSeconds',
    ],
    createGuard,
    guard,
    updateGuard: guard.partial(),
});
